// Options used in shared files
const options = {};
const optionsToAdd = [
  'activeMarket',
  'autoPlayEnabled',
  'bonusBuyDisabled',
  'bonusBuyDisabledOnLimit',
  'currency',
  'currencyDisplayEnabled',
  'extendAutoPlayOptions',
  'fontNameBold',
  'fontNameNormal',
  'isDemo',
  'landscapeMode',
  'landscapeModePromotionDialogWidth',
  'lightningModeDisabled',
  'lightningSpinDisabled',
  'minRoundDurationMs',
  'mute',
  'platform',
  'playerToken',
  'squareMode',
  'stopSpinDisabled',
  'uiDialogPadding',
];

export function setOptions(params) {
  optionsToAdd.forEach((option) => {
    options[option] = params[option];
  });
}

export function getOptions() {
  return options;
}

export function getOption(flag) {
  return options[flag];
}
